import * as React from "react";

import backgroundColoursCss from "../../templates/utils/backgroundColoursCss";
import styled from "../../theme/styled";
import DynamicImage from "../dynamic-image";
import {
  DynamicWrapper,
  IFieldTechnicalArticle,
  IFieldTechnicalArticleColumnType
} from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  content: IFieldTechnicalArticle;
}

interface IParagraphBoxOutSideBySideImagesColumn {
  className: string;
  type: IFieldTechnicalArticleColumnType;
  backgroundColors?: string[];
}

const ParagraphBoxOutSideBySideImagesColumnWrapper = styled<
  IParagraphBoxOutSideBySideImagesColumn,
  "div"
>("div")`
  .content-container {
    ${props => backgroundColoursCss(props.backgroundColors)};

    .content-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .image {
        padding-top: 8%;
        width: 100%;

        &:first-child {
          padding-top: 0;
        }
      }
    }
  }

  @media (min-width: 600px) {
    .content-container {
      .content-wrapper {
        .image {
          padding-top: 4.4rem;
        }
      }
    }
  }

  @media (min-width: 768px) {
    .content-container {
      .content-wrapper {
        flex-direction: row;

        .image {
          padding-top: 0;
          width: 50%;

          &:nth-child(odd) {
            padding-right: 2%;
          }

          &:nth-child(even) {
            padding-left: 2%;
          }
        }
      }
    }
  }
`;

const ParagraphBoxOutSideBySideImagesColumn = ({ type, content }: IProps) => {
  const imgRels = content.relationships;
  const images = imgRels && imgRels.field_images ? imgRels.field_images : [];
  const backgroundColors = content.field_background_colour_s_;

  if (images.length === 0) {
    return null;
  }

  return (
    <ParagraphBoxOutSideBySideImagesColumnWrapper
      className="paragraph-box-out-sidy-by-side-images"
      type={type}
      backgroundColors={backgroundColors}
    >
      <div className="content-container">
        <DynamicWrapper type={type}>
          <div className="content-wrapper">
            {images &&
              images.map((image, i: number) => (
                <div
                  className="image"
                  key={i}
                >
                  <DynamicImage
                    data={image}
                    alt={content.field_images[ i ].alt}
                  />
                </div>
              ))}
          </div>
        </DynamicWrapper>
      </div>
    </ParagraphBoxOutSideBySideImagesColumnWrapper>
  );
};

export default ParagraphBoxOutSideBySideImagesColumn;
